<template>
  <div class="overlay">
  <div class="explanation">
    <h2>{{ explanationTitle }}</h2>
    <p>
      {{ explanation }}
    </p>
    <Button :text="continueGame" type="start" @gamestate="update" />
  </div>
</div>
</template>

<script>
const Button = () => import('./Buttons.vue')

export default {
  name: 'Explanation',
  components: {
    Button
  },
  data: function(){
    return {
      explanationTitle: window.config.text.tutorial.title,
      explanation: window.config.text.tutorial.text,
      showExplanation: this.isShowing,
      continueGame: window.config.text.tutorial.button_okay
    }
  },
  props: {
    isShowing: String
  },
  methods: {
    update(){
      this.$emit('gamestate', 'running')
    }
  }
}
</script>
